<template>
  <div>
    <div>
      <el-button type="primary" plain @click="addUser">新增APP应用</el-button>
      <el-input
        style="width: 200px"
        placeholder="应用名筛选"
        v-model="username"
      ></el-input>
      <el-button @click="getpage(1)">筛选</el-button>
    </div>
    <el-divider></el-divider>
    <div>
      <el-table :data="list">
        <!-- <el-table-column align="center" label="ID" width="180">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.id }}</span>
          </template>
        </el-table-column> -->
        <el-table-column align="center" label="应用名称">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>应用名称: {{ scope.row.name }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium">{{ scope.row.name }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column align="center" label="回调地址">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>回调地址: {{ scope.row.redirectUrl }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag type="success" size="medium">{{
                  scope.row.redirectUrl
                }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column align="center" label="用户删除地址">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>用户删除地址: {{ scope.row.userDelUrl }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag type="danger" size="medium">{{
                  scope.row.userDelUrl
                }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column align="center" label="用户同步地址">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>用户同步地址: {{ scope.row.userSyncUrl }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag type="warning" size="medium">{{
                  scope.row.userSyncUrl
                }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column align="center" label="机构同步地址">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>机构同步地址: {{ scope.row.orgSyncUrl }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag type="warning" size="medium">{{
                  scope.row.orgSyncUrl
                }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column align="center" label="创建日期">
          <template slot-scope="scope">
            <i class="el-icon-time"></i>
            <span style="margin-left: 10px">{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="应用appId">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.appId }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="应用APP秘钥">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.appSecret }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="280" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
              >修改</el-button
            >
            <el-popconfirm
              title="你确定要删除该条目吗？"
              @onConfirm="handleDelete(scope.$index, scope.row)"
            >
              <el-button
                style="margin: 0 10px"
                size="mini"
                type="danger"
                slot="reference"
                >删除</el-button
              >
            </el-popconfirm>
            <!-- <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <page
      @givePageIndex="getpage"
      :index="page"
      :pageSize="pageSize"
      :total="total"
    ></page>
    <el-dialog :title="diaName" :visible.sync="dialogVisible" width="60%">
      <el-form :inline="true" ref="form" :model="form" label-width="100px">
        <el-form-item label="应用APPID">
          <el-input v-model="form.appId"></el-input>
        </el-form-item>
        <el-form-item label="应用APP秘钥">
          <el-input v-model="form.appSecret"></el-input>
        </el-form-item>
        <el-form-item label="应用名称">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="回调地址">
          <el-input v-model="form.redirectUrl"></el-input>
        </el-form-item>
        <el-form-item label="删除地址">
          <el-input v-model="form.userDelUrl"></el-input>
        </el-form-item>
        <el-form-item label="同步地址">
          <el-input v-model="form.userSyncUrl"></el-input>
        </el-form-item>
        <el-form-item label="机构同步地址">
          <el-input v-model="form.orgSyncUrl"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="add">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import treeSelect from "../../components/treeSelect";
import page from "../../components/pages";
export default {
  components: {
    treeSelect,
    page,
  },
  mounted() {
    this.load();
  },
  data() {
    return {
      username: "",
      page: 1,
      pageSize: 10,
      total: 0,
      list: [],
      dialogVisible: false,
      tree: false,
      treeOption: [],
      form: {
        appId: "",
        appSecret: "",
        name: "",
        redirectUrl: "",
        userDelUrl: "",
        userSyncUrl: "",
        orgSyncUrl: "", //机构同步地址
      },
      treeValue: null,
      diaName: "新增APP应用",
    };
  },
  methods: {
    //获取医院code
    treeall(x) {
      this.form.orgId = x.id;
    },
    //打开新增用户页面，请求树形组件内容
    addUser() {
      this.diaName = "新增APP应用";
      this.treeValue = null;
      this.form = {
        appId: "",
        appSecret: "",
        name: "",
        redirectUrl: "",
        userDelUrl: "",
        userSyncUrl: "",
        orgSyncUrl: "", //机构同步地址
      };
      this.dialogVisible = true;
      this.tree = false;
      // this.$api.structureList().then(res => {
      //   // console.log(res)
      //   if (res.data.code == 200) {
      //     this.tree = true;
      //     this.treeOption = res.data.data;
      //   } else {
      //     this.$message.error(res.data.message);
      //   }
      // });
    },
    add() {
      console.log(this.form);
      this.$api
        .addUpdataAppRun(this.form)
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.load();
            this.dialogVisible = false;
          } else {
            this.$message({
              message: res.data.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleEdit(index, row) {
      this.diaName = "修改APP应用";
      // this.treeValue = row.orgId;
      this.form.appId = row.appId;
      this.form.id = row.id;
      this.form.appSecret = row.appSecret;
      this.form.redirectUrl = row.redirectUrl;
      this.form.userDelUrl = row.userDelUrl;
      this.form.userSyncUrl = row.userSyncUrl;
      this.form.orgSyncUrl = row.orgSyncUrl;
      this.form.name = row.name;
      this.dialogVisible = true;
      // this.tree = false;
      // this.$api.structureList().then(res => {
      //   if (res.data.code == 200) {
      //     this.tree = true;
      //     this.treeOption = res.data.data;
      //   }
      // });
      // console.log(index, row);
    },
    //删除用户
    handleDelete(index, row) {
      console.log(row.id);
      this.$api.appDelete(row.id).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.load();
        } else {
          this.$message({
            type: "error",
            message: res.data.message,
          });
        }
      });
      // console.log(index, row);
    },
    load() {
      let obj = {
        pageNo: this.page,
        pageSize: this.pageSize,
        name: this.username,
      };
      console.log(obj);
      this.$api.AppRunList(obj).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          this.list = res.data.data.records;
          this.page = res.data.data.current;
          this.pageSize = res.data.data.size;
          this.total = res.data.data.total;
        }
      });
    },
    getpage(x) {
      //分页
      // console.log(x);
      this.page = x;
      this.load();
    },
  },
};
</script>

<style scoped>
</style>